export default "__VITE_ASSET__DiglrEHB__"